import React, { useEffect, useState } from "react";
import { FaSolarPanel, FaUserCog, FaUsers } from "react-icons/fa";
import { FaBorderTopLeft, FaCartShopping, FaQ } from "react-icons/fa6";
import { MdContactSupport, MdDashboard } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Scrollbar } from "react-scrollbars-custom";
import styled from "styled-components";
import { setTOGGLE } from "../Redux/SidebarReducer";
import Logo from "../UI/Header/logo";
import ElementSidebar from "../UI/Sidebar/ElementSidbar";
import ElementSidbarGroup from "../UI/Sidebar/ElementSidbarGroup";
import AdvertisingSidbar from "../UI/Sidebar/AdvertisingSidbar";
import ElementSidbarHr from "../UI/Sidebar/ElementSidbarHr";
import OrderSidbarWithDropDawn from "../UI/Sidebar/OrderSidbarWithDropDawn";
import PanelsElementSidbarDropDown from "../UI/Sidebar/PanelsElementSidbarDropDown";
import SocialGroupsSidebar from "../UI/Sidebar/SocialGroupsSidbar";

import { Settings, ListAlt as SubListIcon } from "@mui/icons-material";
import { MdCategory, MdRateReview } from "react-icons/md";
import { Can } from "../UI/Can";

const Styles = styled.div`
  .scrollbar-visible .scrollbar-thumb {
    transition: all.3s;
    background: ${({ thememode }) =>
      thememode === "dark"
        ? "rgba(255, 255, 255, 0.4)"
        : "rgba(0, 0, 0, 0.4)"} !important;
  }

  .scrollbar-hidden .scrollbar-thumb {
    background: transparent !important;
    transition: all.3s;
  }

  .scrollbar-thumb:hover {
    background: ${({ thememode }) =>
      thememode === "dark" ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.6)"};
  }

  .scrollbar-track:hover .scrollbar-thumb {
    background: ${({ thememode }) =>
      thememode === "dark"
        ? "rgba(255, 255, 255, 0.4)"
        : "rgba(0, 0, 0, 0.4)"} !important;
  }
`;

const Sidebar = ({ thememode }) => {
  const [scrollbarVisible, setScrollbarVisible] = useState(false); // State to manage scrollbar visibility
  const toggle = useSelector((state) => state.Sidebar.toggle);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window.innerWidth <= 768;
      dispatch(setTOGGLE(!isSmallScreen));
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch]);

  const isAnyModalOpen = useSelector((state) => state.Modal.open);

  const handleScrollStart = () => {
    setScrollbarVisible(true);
  };

  const handleScrollStop = () => {
    setTimeout(() => {
      setScrollbarVisible(false);
    }, 1000);
  };

  return (
    <Styles thememode={thememode}>
      <aside
        className={`list-none text-lg font-medium ${
          isAnyModalOpen ? "z-20" : "z-30"
        }
         bg-secondary dark:bg-darkPrimary text-darkPrimary dark:text-secondary shadow-lg fixed top-0 duration-300 h-screen overflow-hidden font-sans ${
           toggle ? "w-60" : "w-0"
         } ${toggle ? "max-md:w-56" : ""} block ${
          toggle ? "left-0 md:left-0" : "-left-64 md:left-0"
        }`}
        aria-label="Sidebar"
      >
        <Logo thememode={thememode} />
        <Scrollbar
          className={`scrollbar-container ${
            scrollbarVisible ? "scrollbar-visible" : "scrollbar-hidden"
          }`}
          style={{ height: "calc(100vh - 4rem)" }}
          thumbYProps={{
            className: "scrollbar-thumb",
          }}
          trackYProps={{
            className: "scrollbar-track",
          }}
          onScrollStart={handleScrollStart}
          onScrollStop={handleScrollStop}
        >
          <div>
            <Can I="stats" a="dashboard">
              <ElementSidbarGroup title="Home" />
              <ElementSidebar
                title="Dashboard"
                link="Dashboard"
                icon={MdDashboard}
              />
            </Can>
            <ElementSidbarHr />

            <Can
              any={[
                { action: "index", subject: "ourServices" },
                { action: "index", subject: "offers" },
                { action: "store", subject: "ourServices" },
                { action: "store", subject: "offers" },
              ]}
            >
              <ElementSidbarGroup title="Our services" />
            </Can>
            <Can
              any={[
                { action: "index", subject: "ourServices" },
                { action: "store", subject: "ourServices" },
              ]}
            >
              <ElementSidebar
                title="Services"
                link="Shop-ADS"
                icon={FaCartShopping}
              />
            </Can>

            <Can
              any={[
                { action: "index", subject: "offers" },
                { action: "store", subject: "offers" },
              ]}
            >
              <ElementSidebar
                title="Offers"
                link="Offers"
                icon={FaCartShopping}
              />
            </Can>
            <ElementSidbarHr />

            <Can
              any={[
                { action: "index", subject: "orders" },
                { action: "index", subject: "pins" },
                { action: "index", subject: "banners" },
                { action: "index", subject: "topResults" },
                { action: "index", subject: "ticketAds" },
                { action: "store", subject: "orders" },
                { action: "store", subject: "offerOrders" },
              ]}
            >
              <ElementSidbarGroup title="Our Orders" />
            </Can>

            <Can
              any={[
                { action: "index", subject: "orders" },
                { action: "store", subject: "orders" },
                { action: "store", subject: "offerOrders" },
              ]}
            >
              <OrderSidbarWithDropDawn
                title="Order"
                show="Orders"
                icon={FaBorderTopLeft}
              />
            </Can>
            <Can any={[
              { action: "index", subject: "pins" },
              { action: "index", subject: "banners" },
              { action: "index", subject: "topResults" },
              { action: "index", subject: "ticketAds" }
            ]}>
             <AdvertisingSidbar title="Advertising" />
            </Can>

            <ElementSidbarHr />

            <Can
              any={[
                { action: "index", subject: "users" },
                { action: "index", subject: "employees" },
                { action: "index", subject: "panelsReviews" },
                { action: "index", subject: "supportTickets" },
                { action: "store", subject: "users" },
                { action: "store", subject: "employees" },
              ]}
            >
              <ElementSidbarGroup title="People" />
            </Can>

            <Can
              any={[
                { action: "index", subject: "users" },
                { action: "store", subject: "users" },
              ]}
            >
              <ElementSidebar title="Users" link="Users" icon={FaUsers} />
              {/*<CustomElementSidbarDropDown*/}
              {/*  title="User"*/}
              {/*  show="Users"*/}
              {/*  icon={FaUsers}*/}
              {/*/>*/}
            </Can>

            <Can
              any={[
                { action: "index", subject: "employees" },
                { action: "store", subject: "employees" },
              ]}
            >
              <ElementSidebar
                title="Employees"
                link="Employees"
                icon={FaUserCog}
              />
              {/*<CustomElementSidbarDropDown*/}
              {/*  title="Employee"*/}
              {/*  show="Employees"*/}
              {/*  icon={FaUserCog}*/}
              {/*/>*/}
            </Can>

            <Can any={[{ action: "index", subject: "panelsReviews" }]}>
              <ElementSidebar
                title="Reviews"
                link="Reviews"
                icon={MdRateReview}
              />
            </Can>

            <Can any={[{ action: "index", subject: "supportTickets" }]}>
              <ElementSidebar
                title="Support"
                link="Support"
                icon={MdContactSupport}
              />
            </Can>

            <ElementSidbarHr />
            <Can
              any={[
                { action: "index", subject: "panels" },
                { action: "store", subject: "panels" },
              ]}
            >
              <PanelsElementSidbarDropDown
                title="Panel"
                show="Panels"
                icon={FaSolarPanel}
              />
            </Can>

            <Can
              any={[
                { action: "index", subject: "telegramGroups" },
                { action: "index", subject: "whatsappGroups" },
                { action: "index", subject: "skypeGroups" },
              ]}
            >
              <SocialGroupsSidebar title="Social Groups" />
            </Can>

            <Can
              any={[
                { action: "index", subject: "categories" },
                { action: "store", subject: "categories" },
              ]}
            >
              <ElementSidebar
                title="Categories"
                link="Categories"
                icon={MdCategory}
              />
              {/*<CustomElementSidbarDropDown*/}
              {/*    title="Category"*/}
              {/*    show="Categories"*/}
              {/*    icon={MdCategory}*/}
              {/*/>*/}
            </Can>

            <Can
              any={[
                { action: "index", subject: "subcategories" },
                { action: "store", subject: "subcategories" },
              ]}
            >
              <ElementSidebar
                title="SubCategories"
                link="SubCategories"
                icon={SubListIcon}
              />
              {/*<CustomElementSidbarDropDown*/}
              {/*    title="SubCategory"*/}
              {/*    show="SubCategories"*/}
              {/*    icon={MdCategory}*/}
              {/*/>*/}
            </Can>
            <Can
              any={[
                { action: "index", subject: "faqs" },
                { action: "store", subject: "faqs" },
              ]}
            >
              <ElementSidebar title="Faqs" link="Faqs" icon={FaQ} />
              {/*<CustomElementSidbarDropDown*/}
              {/*    title="Faqs"*/}
              {/*    show="Faqs"*/}
              {/*    icon={FaQ}*/}
              {/*/>*/}
            </Can>
            <Can
              any={[
                { action: "index", subject: "marketers" },
                { action: "store", subject: "marketers" },
              ]}
            >
              <ElementSidebar title="Marketers" link="Marketers" icon={FaUsers} />
              {/*<CustomElementSidbarDropDown*/}
              {/*    title="Faqs"*/}
              {/*    show="Faqs"*/}
              {/*    icon={FaQ}*/}
              {/*/>*/}
            </Can>

              <Can
                  any={[
                      { action: "index", subject: "settings" },
                      { action: "update", subject: "settings" },
                  ]}
              >
            <ElementSidebar title="Settings" link="Settings" icon={Settings} />
              </Can>
            <ElementSidbarHr />
          </div>
        </Scrollbar>
      </aside>
    </Styles>
  );
};

export default Sidebar;
